export const JSW_PARENT_PRODUCT = 'JSW';
export const JWM_PARENT_PRODUCT = 'JWM';
export type ParentProducts = typeof JSW_PARENT_PRODUCT | typeof JWM_PARENT_PRODUCT;
